export class ConstantsTableColsWindRichtlinienab { 
    static readonly WINDRICHTUNG: string = 'WINDRICHTUNG';
    static readonly TRANSPORTRICHTUNG: string = 'TRANSPORTRICHTUNG'; 
    static readonly BESCHREIBUNG: string = 'BESCHREIBUNG';
    static readonly WINDHAEUFIGKEIT: string = 'WINDHAEUFIGKEIT';
    static readonly GEBIETSKATEGORIE: string = 'GEBIETSKATEGORIE';
    static readonly ZUL_GERUCHSTUND_GIRL: string = 'ZUL_GERUCHSTUND_GIRL';   

    public static getColumns(): string[]
    {
      return [ 
        this.WINDRICHTUNG + '_' + this.TRANSPORTRICHTUNG + '_' + this.BESCHREIBUNG,
        this.WINDHAEUFIGKEIT,
        this.GEBIETSKATEGORIE,
        this.ZUL_GERUCHSTUND_GIRL,
      ];
    }
  }
 